<template>
   <div class="loader-screen-container">
      <div class="locator">
         <InlinedLoader/>
         <div class="desc">
            <slot/>
         </div>
      </div>
   </div>
</template>

<script>
    import InlinedLoader from "./InlinedLoader";

    export default {
        name: "Loader",
        components: {InlinedLoader}
    }
</script>

<style scoped lang="scss">
   @import "../theme/theme";

   .loader-screen-container {
      position: absolute;
      display: grid;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      justify-items: center;
      align-items: center;

      .locator {
         display: grid;
         font-size: 5rem;
         justify-items: center;
         .desc {
            margin-top: 1rem;
            font-size: 1rem;
            font-weight: 300;
            max-width: 25rem;
            color: $text80;
         }
      }
   }
</style>